import axios from "axios";

// constant
const magicLinkUrl =
  process.env.PUBLIC_BASE_URL + "api/inkle/users/send-magic-link-token/";

export const sendMagicLink = async (payload) =>
  await axios.post(magicLinkUrl, payload);
